<template lang="html">
  <li @click="toggleItem" tabindex="0">
    <span>{{ userGroupData.name }}</span>
    <input type="checkbox" class="sr-only" v-model="checked" @click="toggleItem" aria-label="Tilføj/fjern dette til samlingen">
    <span :class="['material-icons', 'grey-text', {'blue-text' : checked}]" aria-hidden="true">done</span>
  </li>
</template>

<script>
export default {
  data() {
    return {
      checked: false,
    }
  },
  props: {
    userGroupData: {
      required: true,
    },
    type: {
      required: true,
    },
    id: {
      required: true,
    },
  },
  created() {
    for(var i = 0; i < this.userGroupData.likes.length; i++) {
      if(this.userGroupData.likes[i].type == this.type && this.userGroupData.likes[i].value == this.id) {
        this.checked = true;
      }
    }
  },
  methods: {
    toggleItem() {
      console.log(1);
      this.checked = !this.checked;
      this.$emit('toggleItem', this.userGroupData.id);
    },
  },
}
</script>

<style lang="css" scoped>
  li {
    display: table;
    width: 100%;
    height: 50px;
    padding: 10px 10px;
    border-bottom: 1px solid #ddd;
    cursor: pointer;
  }
  li span {
   display: table-cell;
   vertical-align: middle;
  }

  li .material-icons {
   right: 0px;
   position: relative;
   height: 30px;
   width: 30px;
  }
</style>
